import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import appSettings from "../mixins/config/appSettings"
import {authGuard} from "@/auth/sanctum/guards/auth_guard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About.vue')
  },
  {
    path: '/lmra',
    name: 'lmra',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Lmra.vue')
  },
  {
    path: '/report_incident',
    name: 'report_incident',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/IncidentReport.vue')
  },
  {
    path: '/report_near_incident',
    name: 'report_near_incident',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/NearIncidentReport.vue')
  },
  {
    path: '/risk_analysis',
    name: 'risk_analysis',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/RiskAnalysisReport.vue')
  },
  {
    path: '/corona_analysis',
    name: 'corona_analysis',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/RiskAnalysisReport.vue')
  },
  {
    
    path: '/scan_qr',
    name: 'scan_qr',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/QrCodeScanner.vue')
  },
  {
    path: '/process_issue',
    name: 'process_issue',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ReportProcessIssue.vue')
  },
  {
    path: '/checklist',
    name: 'checklist',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Checklist.vue')
  },
  {
    path: '/emergency_numbers',
    name: 'emergency_numbers',
    beforeEnter: authGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/EmergencyNumbers.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function(to, from, next) {
  let route = null;
  switch(to.name){
    case 'report_near_incident':
      if(!appSettings.data().appSettings.usesNearIncidentReports){
        route = '/';
      }
      break;
    case 'scan_qr':
      if(!appSettings.data().appSettings.usesQRCodeScanner){
        route = '/';
      }
      break;
    case 'process_issue':
      if(!appSettings.data().appSettings.usesReportProcessIssue){
        route = '/';
      }
      break;
    case 'risk_analysis':
      if(!appSettings.data().appSettings.usesRiskAnalysis){
        route = '/';
      }
      break;
    case 'corona_analysis':
      if(!appSettings.data().appSettings.usesCoronaRiskAnalysisVariant){
        route = '/';
      }
      break;
    default:
      break;
  }

  if(route === null){
    next();
  }else{
    next(route);
  }
});

export default router
